import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl } from "@angular/forms";
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import Swal from 'sweetalert2';
import { MyClass, KeyWord } from '../../my-class'

import { LoginService } from '../../services/login.service';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.css']
})
export class AddComponent implements OnInit {
    
    public session_data: any = {};
  public err: any = {};
  public result: any = {};
  public data: any = {};
  public form: any = {};

  constructor(private login: LoginService, private router: Router, public fb: FormBuilder,
    private spinner: NgxSpinnerService, private service: DashboardService) {
    this.session_data.id = login.get_session_data('ieye_session_id');
    this.service.setTitle('Add Project | 24ieye');
    if(this.session_data.id == 2){
        this.router.navigate(['projects']);
    }
    this.form = this.fb.group({
      str_name: [''],
      str_language: ['any'],
      keywords: this.fb.array([this.fb.group({keyword:'', id: ''})])
    });
  }

  ngOnInit(): void {
  }
  
  public async add_project() {
    this.spinner.show();
    var formData: any = new FormData();
    formData.append("str_name", this.form.value.str_name);
    formData.append("str_language", this.form.value.str_language);
    formData.append("keywords", JSON.stringify(this.form.value.keywords));

    this.result = await this.service.form_actions(formData, 'add_project');
    this.spinner.hide();
    if (this.result == 'error') {
      Swal.fire('Alert!', 'Something went wrong! Please try again later.', 'error');
      return false;
    }
    if (this.result.status == false) {
      if (this.result.code == 202) {
        this.err = {};
        Swal.fire('Alert!', this.result.message, 'error');
      } else {
        this.err = this.result.errors;
      }
    } else {
      Swal.fire({ icon: 'success', title: this.result.message, showConfirmButton: false, timer: 1500 })
      setTimeout(() => {
        this.router.navigate(['projects']);
      }, 2000);
    }
  }
  
  get keywords() {
    return this.form.get('keywords') as FormArray;
  }
  
  addKeyword() {
    this.keywords.push(this.fb.group({keyword:'', id:''}));
  }
  
  deleteKeyword(index) {
    this.keywords.removeAt(index);
  }

}
